export default "__VITE_ASSET__C6mj1LJt__"